import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";

/** An axios failure as RTK Query's error: the backend's status and body when it answered, else FETCH_ERROR. */
export const toBackgroundJobFetchError = (e: unknown): FetchBaseQueryError => {
  if (axios.isAxiosError(e) && e.response) {
    return { status: e.response.status, data: e.response.data } as FetchBaseQueryError;
  }
  return { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError;
};
